import { SPEND_TYPE } from 'Data/constants';
import {
	convertMeasuresToWaterfallFilter,
	TAIL_SPEND,
} from 'utils/detailsChartDataConverter';

export const COMPANY_FILTER_KEY = 'company';

export const applyMaxPointWidthWrapper = H => {
	var each = H.each;
	H.wrap(H.seriesTypes.column.prototype, 'drawPoints', function(proceed) {
		var series = this;
		if (series.data.length > 0) {
			var width =
				series.barW > series.options.maxPointWidth
					? series.options.maxPointWidth
					: series.barW;
			each(this.data, function(point) {
				point.shapeArgs.x += (point.shapeArgs.width - width) / 2;
				point.shapeArgs.width = width;
			});
		}
		proceed.call(this);
	});
};

export const getHeroChartParamsFromProps = props => {
	const {
		waterfallShowAdjusted: adjusted,
		waterfallShowClientCategory: includeCustomCategories,
		currency,
		showNonSourceable,
		dateFrom,
		dateTo,
		dimensions,
		customFilters,
		customFiltersValues,
		apiCacheTrigger,
		showHarmonizedVendors,
		othersThreshold,
		showAllCategories,
		storedQueryId,
		showTailSpend,
		pmiBreadcrumbs,
		companiesList,
	} = props;

	const {
		waterfallCategory: categoryName,
		waterfallCategoryLevel: categoryLevel,
		waterfallCategoryHierarchy: hierarchy,
		isTailSpend,
	} = convertMeasuresToWaterfallFilter(pmiBreadcrumbs, 4);

	const companies = getCompaniesWithDefaults(props.companies, companiesList);
	const filters = [...customFilters];
	const filterValues = [...customFiltersValues];
	companies.forEach(companyName => {
		filters.push(COMPANY_FILTER_KEY);
		filterValues.push(companyName);
	});

	const params = {
		categoryName,
		categoryLevel,
		hierarchy,
		isTailSpend,
		adjusted,
		dateFrom,
		dateTo,
		currency,
		includeCustomCategories,
		harmonized: showHarmonizedVendors,
		filters,
		filterValues,
		showNonSourceable,
		storedQueryId,
		dimensions,
		apiCacheTrigger,
		othersThreshold,
		showAllCategories,
		showTailSpend,
		addCompaniesData: true,
		isPmi: true,
	};

	return params;
};

export const getIsTailSpendFromBreadcrumbs = pmiBreadcrumbs => {
	return !!(pmiBreadcrumbs || []).find(item => item === TAIL_SPEND);
};

export const getHeroChartFileExportParamsFromProps = props => {
	const params = getHeroChartParamsFromProps(props);

	const { pmiBreadcrumbs, showTailSpend } = props;
	let {
		filters = [],
		filterValues = [],
		isTailSpend,
		showNonSourceable,
		currency,
		currencyType,
		dateFrom,
		dateTo,
		harmonized,
		storedQueryId,
		dimensions,
	} = params;

	let hierarchy = pmiBreadcrumbs.filter(name => name !== TAIL_SPEND);
	let spendType = hierarchy.shift();
	spendType = spendType && spendType.toLowerCase();
	hierarchy = hierarchy.slice(0, 3); // max 3 items in hierarchy
	let includeTailSpend = !showTailSpend;
	let getTailSpendOnly = isTailSpend;

	if (spendType) {
		filters = [...filters, 'spendType'];
		filterValues = [...filterValues, spendType === SPEND_TYPE.INDIRECT ? 1 : 0];
	}
	if (currency) {
		currencyType = 'fixed';
	}

	filters = [...filters, 'sourceable'];
	filterValues = [...filterValues, !showNonSourceable];

	return {
		hierarchy,
		includeTailSpend,
		getTailSpendOnly,
		filters,
		filterValues,
		currency,
		currencyType,
		dateFrom,
		dateTo,
		harmonized,
		storedQueryId,
		dimensions,
	};
};

export const getCompaniesWithDefaults = (companies, companiesList) => {
	if (
		(!companies || companies.length === 0) &&
		companiesList &&
		companiesList.length > 0
	) {
		companies = [...companiesList].slice(0, 4);
	}

	return companies;
};
